module.exports = __webpack_public_path__ + "img/right-arrow.b0970222.svg";